/**
 * @Author: wuyang
 * @Date: 2024/1/10
 * @Description: ""
 */
import {
	BaseAbstractClass,
	IBaseAbstractClassProps
} from '@/helper/base/BaseAbstractClass'
import { ETaskStatus, ITaskListItem } from '@/types/task'
import { EBizPhone } from '@/types/bizPhone'
import { createTask, deleteTask } from '@/api/task'
import { IBaseEventMitt } from '@/helper/base/BaseAtomMethodClass'
import { getTaskListQuery } from '@/common/client/taskQuery'
import { AtomManager } from '@/helper/managers/atom-manager/AtomManager'
import { AtomWithQueryResult } from 'jotai-tanstack-query'
import { IAtomMethod } from '@/helper/store/createStore'

interface ITaskListServiceMittProps extends IBaseEventMitt {
	onStatusChange: {
		taskId: string
		status: ETaskStatus
	}
}

export interface ITaskListServiceProps
	extends IBaseAbstractClassProps<ITaskListServiceMittProps> {
	// type 任务类型
	type: EBizPhone
}

export class TaskListService extends BaseAbstractClass<
	ITaskListServiceProps,
	ITaskListServiceMittProps
> {
	readonly type: EBizPhone
	taskListQuery?: IAtomMethod<AtomWithQueryResult<ITaskListItem[], Error>>
	taskItemMap = new AtomManager<string, ITaskListItem>({})
	constructor(props: ITaskListServiceProps) {
		//console.log(props.type+'任务类型'); 有回调延时
		super(props)
		this.type = props.type
		if (props.type === 0 || props.type === 1 || props.type === 5) {
			this.taskListQuery = this.genAtomMethod(getTaskListQuery(props.type))
			console.log(getTaskListQuery(props.type))
		} else {
			// 其他 type 保持 undefined 或赋空值
			this.taskListQuery = undefined
		}

		this.init(props)
	}
	syncInit(props: ITaskListServiceProps) {
		super.syncInit(props)
	}

	// 刷新我的任务列表
	async refresh() {
		if (!this.taskListQuery) {
			return
		}
		const taskListQuery = this.taskListQuery.get()

		return taskListQuery
			.refetch({ cancelRefetch: true })
			.then((result) => {
				this.taskItemMap.clearItem()
				const { data = [] } = result
				for (let i = 0; i < data.length; i++) {
					const taskId = data[i].taskId
					this.taskItemMap.addItem(taskId, data[i])
				}
			})
			.catch((err) => {
				console.log('www--------->err', err)
			})
	}

	// 更行每个状态
	updateTaskById(taskId: string, taskData: Partial<ITaskListItem>) {
		const defaultData = this.taskItemMap.getItem(taskId)?.get()
		if (defaultData&&taskData.taskId) {
			const currentTaskData = Object.assign({}, defaultData, taskData)
			this.taskItemMap.updateItem(taskId, currentTaskData)
		}
	}

	destory() {
		super.destory()
	}

	// 创建任务
	async createTask({ url }: { url: string }) {
		return createTask({
			originalUrl: url,
			type: this.type
		})
	}

	// 批量删除任务
	async patchDeleteTask(taskIds: string[]) {
		for (let i = 0; i < taskIds.length; i++) {
			this.taskItemMap.delItem(taskIds[i])
		}
		return deleteTask(taskIds)
	}
}
